import getParameterByName from "./getQueryParams";

function isRenewal() {
  return (
    typeof window !== "undefined" &&
    window?.location?.href?.includes("/renew-policy")
  );
}

export const getUtmParams = () => {
  return {
    utm_source: getParameterByName("utm_source"),
    utm_medium: getParameterByName("utm_medium"),
    utm_campaign: getParameterByName("utm_campaign")
  };
};

export default isRenewal;
